"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("@emotion/react");
var makeModalStylings = function () {
    var theme = (0, react_1.useTheme)();
    return {
        box: (0, react_1.css)({
            backgroundColor: 'rgb(255, 255, 255)',
            overflowY: 'auto',
            padding: theme.mvf.spacing.medium,
            margin: '0 auto',
            borderStyle: 'solid',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 'fit-content',
            minWidth: "30%",
            maxWidth: "80%",
            borderWidth: theme.mvf.border.width.thin,
            height: 'fit-content',
            minHeight: "30%",
            maxHeight: "80%",
            borderColour: theme.mvf.palette.component.answerUnselectedColor,
        }),
        close: (0, react_1.css)({
            position: 'absolute',
            color: theme.mvf.palette.text.secondaryTextColor,
            cursor: 'pointer',
        }),
        text: (0, react_1.css)({
            marginTop: 20,
            display: 'inline-block',
            textAlign: 'left',
            fontFamily: theme.mvf.typography.fontFamily,
            lineHeight: theme.mvf.lineHeight.medium,
        }),
    };
};
exports.default = makeModalStylings;
//# sourceMappingURL=makeModalStylings.js.map